import { SizeVO } from 'library/ts/model/vo/SizeVO';
import * as NumberModule from 'library/ts/utilities/modules/Number';
export const dynamicValue = (baseContainerSize, latestContainerSize, baseValue, minValue, maxValue) => {
    const baseArea = baseContainerSize.width * baseContainerSize.height;
    const realArea = latestContainerSize.width * latestContainerSize.height;
    const percent = realArea / baseArea;
    let newValue = (baseValue * percent);
    newValue = NumberModule.clamp(newValue, minValue, maxValue);
    return newValue;
};
export const proportionalResize = (currentWidth, currentHeight, desiredWidth, desiredHeight) => {
    const output = new SizeVO();
    output.width = 0;
    output.height = 0;
    const targetRatio = desiredWidth / desiredHeight;
    const currentRatio = currentWidth / currentHeight;
    if (currentRatio > targetRatio) {
        output.width = desiredWidth;
        output.height = currentHeight * (output.width / currentWidth);
    }
    else {
        output.height = desiredHeight;
        output.width = currentWidth * (output.height / currentHeight);
    }
    if (currentRatio === 1) {
        if (desiredWidth > desiredHeight || desiredWidth < desiredHeight) {
            output.height = currentHeight * (output.width / currentWidth);
            output.width = currentWidth * (output.height / currentHeight);
        }
        if (desiredWidth === desiredHeight) {
            output.height = desiredHeight;
            output.width = desiredWidth;
        }
    }
    return output;
};
